import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from './';

class CargadorSuspense extends Component {
  renderError() {
    if (this.props.mostrar_error_app === true) { return <><p className="alertasRojas alertasCorto">{ this.props.error_app }</p><br /></>; }

    return null;
  }

  render() {
    return (
      <section className="contenedor cajeadoVertical cajeadoHorizontal" style={{ overflowY: 'hidden' }}>
        <header>
          <h1 className="sr-only">Blog de administración de sistemas y programación | Antarie</h1>
        </header>

        <article>
          {this.renderError()}

          <Spinner size="Big" />

          <p className="fontBig textoAzulBold margenSuperiorBig textoCentrado" >Cargando Antarie</p>
          <p className="fontBig textoAzulBold textoCentrado margenInferiorBig">Bienvenido</p>
        </article>
      </section>
    );
  }
}

const mapStateToProps = ({ app }) => {
  const { error_app, mostrar_error_app } = app;

  return { error_app, mostrar_error_app };
};

export default connect(mapStateToProps, null)(CargadorSuspense);
